import { useExam } from "../../context/ExamContext";
import React, { useState, useEffect } from "react";
import useScrollToActiveQuestion from "../../hooks/useScrollToActiveQuestion";

function SingleChoice({ question, isTrueFalse }) {
  const { updateAnswer, activeQuestion, answers } = useExam();
  const scrollRef = useScrollToActiveQuestion(question.questionNumber);

  const handleChange = (e) => {
    updateAnswer({
      questionNumber: question.questionNumber,
      answer: e.target.value,
    });
  };

  const selectedAnswer = answers.find(
    (a) => a.questionNumber === question.questionNumber
  )?.answer;

  return (
    <div className="single-choice" ref={scrollRef}>
      <div className="single-question">
        {question.answers.map((answerObj) => (
          <div key={answerObj.key}>
            <input
              type="radio"
              id={`${question.questionNumber}-${answerObj.key}`}
              value={answerObj.key}
              onChange={handleChange}
              checked={selectedAnswer === answerObj.key}
            />
            <label
              className="cursor-pointer"
              htmlFor={`${question.questionNumber}-${answerObj.key}`}
            >
              {isTrueFalse
                ? answerObj.answer.toUpperCase()
                : answerObj.answer}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SingleChoice;
